// Dynamic loader for Leaflet library and stylesheet from CDN
export const loadLeaflet = () => {
    if (window.L) return Promise.resolve(window.L);
    if (window.__leafletPromise) return window.__leafletPromise;

    window.__leafletPromise = new Promise((resolve, reject) => {
        if (!document.querySelector('link[href*="leaflet.css"]')) {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
            document.head.appendChild(link);
        }

        const existingScript = document.querySelector('script[src*="leaflet.js"]');
        if (existingScript) {
            if (window.L) return resolve(window.L);
            existingScript.addEventListener('load', () => resolve(window.L));
            existingScript.addEventListener('error', reject);
            return;
        }

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
        script.async = true;
        script.onload = () => resolve(window.L);
        script.onerror = () => reject(new Error('Failed to load Leaflet from CDN'));
        document.head.appendChild(script);
    });

    return window.__leafletPromise;
};
